/**
 * Type definitions for peertube-client 0.0.0
 * Project: https://github.com/charjac/peertube-client
 * Definitions by: Charles Jacquin <https://github.com/charjac>
 * Definitions: https://github.com/charjac/peertube-client
 * TypeScript Version: 3.2
 */

export { Peertube } from './peertube';
